var nativeFunctionToString = require('../internals/function-to-string');
var WeakMap = require('../internals/global').WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/internals/native-weak-map.js
// module id = 573
// module chunks = 0